// Add firebase in this code -------------------------------------------

/* eslint-disable no-shadow */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable prefer-template */
/* eslint-disable radix */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import moment from 'moment';
import { useMutation, useQuery } from '@apollo/client';
import { Button, Col, Input, List, Row, Spinner, UncontrolledTooltip } from 'reactstrap';
import { FiEdit2, FiRefreshCw, FiInfo } from 'react-icons/fi';
import { RiVerifiedBadgeFill } from 'react-icons/ri';
import { X } from 'lucide-react';
import { toast } from 'react-toastify';

// Absolute imports (from components/...) should come first
import { getTraderHistoryQuery, VENDORS_QUERY } from 'utils/CommonGraphQL';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import { indiaCallingCodeId } from 'constants';
import {
  ASSIGN_TRADERS_TO_ANOTHER_BDE,
  ASSIGN_TRADERS_TO_ANOTHER_RM,
  ASSIGN_TRADERS_TO_DEDICATED_PURCHASE_MANAGER,
} from 'pages/Staff/StaffgraphQL';
import { UPDATE_TRADER_DESIGNATION } from 'pages/Vendor/VendorGraphQL';
import Loader from 'components/common/Loader';
import CardWithTitle from 'components/CardWithTitle';
import ProfileNameCard from 'components/ProfileNameCard';
import ErrorBoundary from 'components/common/ErrorBoundary';
import FSBModal from 'components/common/FSBModal';
import RMField from 'components/RMField';
import BDEField from 'components/BDEField';
import PMField from 'components/PMField';

// Relative imports (from ./components/...) should come after absolute imports
import VendorDetailTabs from './components/VendorDetailTabs';
import VendorKyc from './components/VendorKyc';
import VendorForeignKyc from './components/VendorForeignKyc';
import VendorAdditionalUser from './components/VendorAdditionalUser';
import VendorBillingAndPayment from './components/VendorBillingAndPayment';
import VendorAddOnListing from './components/VendorAddOnListing';
import VendorSubscribe from './components/VendorSubscribe';
import VendorSubscribeAddOn from './components/VendorSubscribeAddOn';
import SellerCommissionHistory from './components/SellerCommission';
import VendorSubscriptionQuantity from './components/VendorSubscriptionQuantity';
import VendorFavouriteGrades from './components/VendorFavouriteGrades';
import VendorCommission from './components/VendorCommission';
import GstVerificationInput from './components/GstVerificationInput';

const TIMELINE_ENTRIES_PER_PAGE = 15;
const INDIA_UTC_OFFSET = '+05:30';

const getIndiaMoment = (date) => moment(date).utcOffset(INDIA_UTC_OFFSET);

const getNumericId = (value) => {
  const numericId = Number(value);
  return Number.isNaN(numericId) ? null : numericId;
};

const getGstLocationParts = (location = '') => {
  const parts = String(location)
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);
  const pinCodeIndex = parts.findIndex((part) => /^\d{6}$/.test(part));
  const pinCode = pinCodeIndex >= 0 ? parts[pinCodeIndex] : '';
  const addressEndIndex =
    pinCodeIndex > 1
      ? pinCodeIndex - 2
      : pinCodeIndex >= 0
        ? pinCodeIndex
        : parts.length;
  return {
    address: parts.slice(0, addressEndIndex).join(', '),
    pinCode,
  };
};

const formatTradedVolume = (volume) =>
  Number(volume || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 });

const getTimelineValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return 'Not Available';
  }

  return value;
};

const getTimelineIcon = (action = '') => {
  const actionText = action.toLowerCase();
  return actionText.includes('created') || actionText.includes('entered')
    ? 'refresh'
    : 'edit';
};

const getTimelineTitle = (action = '') =>
  action.toLowerCase() === 'trader type updated' ? 'User Role updated' : action;

const getTimelineListValues = (value) => {
  if (!value || value === 'Not Available') {
    return [];
  }

  return String(value)
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
};

const getFavoriteGradeTimelineLines = (oldValue, newValue) => {
  const oldGrades = getTimelineListValues(oldValue).map((grade) =>
    grade.toLowerCase(),
  );
  const newGrades = getTimelineListValues(newValue);
  const oldGradeSet = new Set(oldGrades);
  const addedGrades = newGrades.filter(
    (grade) => !oldGradeSet.has(grade.toLowerCase()),
  );

  if (addedGrades.length) {
    return [`${addedGrades.join(', ')} new added favorite grade`];
  }

  const newGradeSet = new Set(newGrades.map((grade) => grade.toLowerCase()));
  const removedGrades = getTimelineListValues(oldValue).filter(
    (grade) => !newGradeSet.has(grade.toLowerCase()),
  );

  if (removedGrades.length) {
    return [`${removedGrades.join(', ')} removed favorite grade`];
  }

  return ['Favorite grade updated'];
};

const getTimelineLines = (item) => {
  if (item.action?.toLowerCase().includes('favorite grade')) {
    return getFavoriteGradeTimelineLines(item.oldValue, item.newValue);
  }

  if (item.action?.toLowerCase().includes('favorite sector')) {
    if (item.metadata) {
      let metaStr = item.metadata;
      try {
        const metaObj = JSON.parse(item.metadata);
        if (metaObj.sectorName) {
          metaStr = metaObj.sectorName;
        } else if (metaObj.subCategoryName) {
          metaStr = metaObj.subCategoryName;
        } else if (metaObj.name) {
          metaStr = metaObj.name;
        }
      } catch (e) {
        // Not JSON, use raw metadata string
      }
      
      // Determine if it was added or removed based on whether New has more grades than Old
      // But since we might not have a reliable way to check, we can just say "Favorite sector updated: SectorName"
      // Or check lengths:
      const oldLen = item.oldValue ? item.oldValue.length : 0;
      const newLen = item.newValue ? item.newValue.length : 0;
      const verb = newLen >= oldLen ? 'added to' : 'removed from';
      
      return [`${metaStr} ${verb} favorite sector`];
    }
    // If no metadata, it will fallback to returning Old and New below
  }

  return [
    `Old: ${getTimelineValue(item.oldValue)}`,
    `New: ${getTimelineValue(item.newValue)}`,
  ];
};

const buildTraderTimelineHistory = (history, visibleEntryCount) => {
  const sortedHistory = [...(history || [])].sort(
    (current, next) =>
      moment(next.createdAt).valueOf() - moment(current.createdAt).valueOf(),
  );

  const visibleHistory =
    typeof visibleEntryCount === 'number'
      ? sortedHistory.slice(0, visibleEntryCount)
      : sortedHistory;

  return visibleHistory.reduce((groups, item) => {
    const createdAtIndia = getIndiaMoment(item.createdAt);
    const dateKey = createdAtIndia.format('YYYY-MM-DD');
    const date = createdAtIndia.format('MMM D, YYYY');
    const currentGroup = groups.find((group) => group.dateKey === dateKey);
    const activity = {
      id: item.id,
      time: createdAtIndia.format('hh:mm A'),
      icon: getTimelineIcon(item.action),
      title: getTimelineTitle(item.action),
      lines: getTimelineLines(item),
      meta: `by ${item.updatedByName || 'System'} ${date}`,
    };

    if (currentGroup) {
      currentGroup.activities.push(activity);
      return groups;
    }

    return [
      ...groups,
      {
        dateKey,
        date,
        activities: [activity],
      },
    ];
  }, []);
};

const VendorDetails = ({ vendorId, drawerToggle }) => {
  const [showAddRecord, setAddRecord] = useState({
    status: false,
    row: '',
    type: ADD_EDIT_CONSTANT.ADD,
  });
  const [addOnRecord, setAddOnRecord] = useState({
    status: false,
    row: '',
    type: ADD_EDIT_CONSTANT.ADD,
  });
  const [showSellerCommisionHistory, setShowSellerCommisionHistory] =
    useState(false);
  const [visibleTimelineEntries, setVisibleTimelineEntries] = useState(
    TIMELINE_ENTRIES_PER_PAGE,
  );
  const [selectedPurchaseManager, setSelectedPurchaseManager] = useState(null);
  const vendorNumericId = getNumericId(vendorId);

  const toggleAddRecord = (row, type) => {
    setAddRecord({ status: !showAddRecord.status, row, type });
  };

  const toggleAddOnRecord = (row, type) => {
    setAddOnRecord({ status: !addOnRecord.status, row, type });
  };

  const toggleSellerCommission = () => {
    setShowSellerCommisionHistory(!showSellerCommisionHistory);
  };

  const { data, loading, error, refetch } = useQuery(VENDORS_QUERY, {
    variables: {
      filter: [{ key: 'id', value: vendorNumericId, type: 'INT', op: 'EQ' }],
      pageNo: 1,
      pageSize: 10,
      sortCol: null,
      sortDirection: null,
    },
    skip: !vendorNumericId,
    fetchPolicy: 'network-only',
  });

  const traderHistoryQuery = useMemo(
    () => getTraderHistoryQuery(vendorNumericId || 0),
    [vendorNumericId],
  );

  const {
    data: traderHistoryData,
    loading: traderHistoryLoading,
    error: traderHistoryError,
    refetch: refetchTraderHistory,
  } = useQuery(traderHistoryQuery, {
    skip: !vendorNumericId,
    fetchPolicy: 'network-only',
  });

  const refreshVendorTimeline = () => {
    setVisibleTimelineEntries(TIMELINE_ENTRIES_PER_PAGE);
    Promise.all([refetch(), refetchTraderHistory()]).catch((err) => {
      console.error(err);
    });
  };

  const [assignTradersToAnotherRM] = useMutation(ASSIGN_TRADERS_TO_ANOTHER_RM, {
    onCompleted: ({ assignTradersToAnotherRM }) => {
      if (assignTradersToAnotherRM?.status === 200)
        toast.success(assignTradersToAnotherRM?.message);
      refreshVendorTimeline();
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
    },
  });

  const [assignTradersToAnotherBDE] = useMutation(
    ASSIGN_TRADERS_TO_ANOTHER_BDE,
    {
      onCompleted: ({ assignTradersToAnotherBDE }) => {
        if (assignTradersToAnotherBDE?.status === 200)
          toast.success(assignTradersToAnotherBDE?.message);
        refreshVendorTimeline();
      },
      onError: ({ graphQLErrors }) => {
        graphQLErrors.map(({ exception }) => {
          toast.error(exception?.message);
          return exception;
        });
      },
    },
  );

  const [assignTradersToDedicatedPurchaseManager] = useMutation(
    ASSIGN_TRADERS_TO_DEDICATED_PURCHASE_MANAGER,
    {
      onCompleted: ({ assignTradersToDedicatedPurchaseManager }) => {
        if (assignTradersToDedicatedPurchaseManager) {
          toast.success(assignTradersToDedicatedPurchaseManager);
        }
        refreshVendorTimeline();
      },
      onError: ({ graphQLErrors }) => {
        graphQLErrors.map(({ exception }) => {
          toast.error(exception?.message);
          return exception;
        });
      },
    },
  );

  const [designationInput, setDesignationInput] = useState('');
  const [isEditingDesignation, setIsEditingDesignation] = useState(false);

  const [updateTraderDesignationMutation, { loading: updatingDesignation }] =
    useMutation(UPDATE_TRADER_DESIGNATION, {
      onCompleted: (res) => {
        toast.success(
          res?.updateTraderDesignation || 'Designation updated successfully',
        );
        setIsEditingDesignation(false);
        refetch();
      },
      onError: (err) => {
        const errorMsg =
          err?.graphQLErrors?.[0]?.message ||
          err?.message ||
          'Failed to update designation';
        toast.error(errorMsg);
      },
    });

  const hasShownToastRef = useRef(false);

  useEffect(() => {
    if (loading || hasShownToastRef.current) return;
    const traders = data?.traders?.traders || [];
    if (error || traders.length === 0) {
      hasShownToastRef.current = true;
      toast.error('Cannot get detail');
      if (drawerToggle) drawerToggle();
    }
  }, [loading, error, data, drawerToggle]);

  useEffect(() => {
    setVisibleTimelineEntries(TIMELINE_ENTRIES_PER_PAGE);
  }, [vendorId]);

  useEffect(() => {
    const trader = data?.traders?.traders?.[0];
    if (trader?.dedicatedPurchaseManager) {
      setSelectedPurchaseManager(trader.dedicatedPurchaseManager);
    } else {
      setSelectedPurchaseManager(null);
    }
    setDesignationInput(trader?.designation || '');
    setIsEditingDesignation(false);
  }, [vendorId, data]);

  const handleSaveDesignation = async () => {
    if (!designationInput?.trim()) {
      toast.error('Please enter designation');
      return;
    }
    const traderId = data?.traders?.traders?.[0]?.id;
    if (!traderId) return;

    try {
      await updateTraderDesignationMutation({
        variables: {
          traderId: String(traderId),
          designation: designationInput.trim(),
        },
      });
    } catch (e) {
      console.error(e);
    }
  };

  if (loading) return <Loader />;
  if (error) return null;
  if (!data?.traders?.traders?.length) return null;

  const {
    firstName,
    middleName,
    lastName,
    email,
    phone,
    addresses,
    profile,
    id,
    kyc,
    callingCode,
    callingCodeId,
    companyFormationNumber,
    userSubscription,
    dedicatedRM,
    dedicatedBDE,
    dedicatedPurchaseManager,
    isParentTrader,
    kycStatus,
    totalTradedVolume,
    // parentTrader,
    // sellerOrderCommissionPaid,
    // sellerCumulativeOrderQty,
    status,
    tradeGstIn,
    favGrades,
    designation,
  } = data.traders.traders[0];
  const gstLocationParts = getGstLocationParts(kyc?.gstLocation);
  const traderTimelineHistory = buildTraderTimelineHistory(
    traderHistoryData?.traderHistory,
    visibleTimelineEntries,
  );
  const totalTimelineEntries = traderHistoryData?.traderHistory?.length || 0;
  const canLoadMoreTimeline = visibleTimelineEntries < totalTimelineEntries;
  const renderTimelineHistory = () => {
    if (traderHistoryLoading) {
      return <div className="mb-2">Loading...</div>;
    }

    if (traderHistoryError || !traderTimelineHistory.length) {
      return <div className="mb-2">Not Available</div>;
    }

    return traderTimelineHistory.map((group) => (
      <div className="vendor-timeline-group" key={group.dateKey}>
        <span className="vendor-timeline-date">{group.date}</span>
        {group.activities.map((activity) => (
          <div className="vendor-timeline-item" key={activity.id}>
            <span className="vendor-timeline-time">{activity.time}</span>
            <span className="vendor-timeline-icon">
              {activity.icon === 'refresh' ? (
                <FiRefreshCw size={13} />
              ) : (
                <FiEdit2 size={13} />
              )}
            </span>
            <div className="vendor-timeline-content">
              <p className="vendor-timeline-title">{activity.title}</p>
              {activity.lines?.map((line) => (
                <p className="vendor-timeline-line" key={line}>
                  {line}
                </p>
              ))}
              <p className="vendor-timeline-meta">{activity.meta}</p>
            </div>
          </div>
        ))}
      </div>
    ));
  };

  return (
    <>
      {showSellerCommisionHistory && (
        <FSBModal
          size="xl"
          title="Commission History"
          closeButtonLabel=""
          confirmButtonLabel=""
          message=""
          open={showSellerCommisionHistory}
          toggleAlert={toggleSellerCommission}
          onClose={toggleSellerCommission}
          modalClass="right-drawer right-drawer-details"
        >
          <SellerCommissionHistory
            sellerId={id}
            drawerToggle={toggleSellerCommission}
            currency={callingCodeId === indiaCallingCodeId ? 'INR' : 'USD'}
          />
        </FSBModal>
      )}

      {showAddRecord.status && (
        <FSBModal
          size="xl"
          title="Subscribe"
          closeButtonLabel=""
          confirmButtonLabel=""
          message=""
          open={showAddRecord.status}
          toggleAlert={toggleAddRecord}
          onClose={toggleAddRecord}
          modalClass="right-drawer right-drawer-details"
        >
          <VendorSubscribe
            id={id}
            row={showAddRecord.row}
            currency={callingCodeId === indiaCallingCodeId ? 'INR' : 'USD'}
            type={showAddRecord.type}
            drawerToggle={toggleAddRecord}
            refetch={refetch}
          />
        </FSBModal>
      )}
      {addOnRecord.status && (
        <FSBModal
          size="xl"
          title="ADD ON"
          closeButtonLabel=""
          confirmButtonLabel=""
          message=""
          open={addOnRecord.status}
          toggleAlert={toggleAddOnRecord}
          onClose={toggleAddOnRecord}
          modalClass="right-drawer right-drawer-details"
        >
          <VendorSubscribeAddOn
            id={id}
            row={addOnRecord.row}
            currency={callingCodeId === indiaCallingCodeId ? 'INR' : 'USD'}
            type={addOnRecord.type}
            drawerToggle={toggleAddOnRecord}
            refetch={refetch}
          />
        </FSBModal>
      )}
      <CardWithTitle title="">
        <Row className="align-items-center">
          <Col sm={6} lg={4}>
            <div className="d-flex align-items-center mb-2">
              <ProfileNameCard
                wrapperClass=""
                profile={profile}
                fname={firstName && firstName[0]}
                lname={lastName && lastName[0]}
              />
              <div className="ms-3">
                <p className="f-14 text-dark-525 fw-medium mb-1">
                  {firstName} {middleName ? `${middleName} ` : ''}{lastName}
                </p>
                <p className="f-12 mb-0 text-active fw-medium">{email}</p>
                <p className="f-12 mb-0 text-active fw-medium">
                  {`${callingCode?.callingCode}-${phone}`}
                </p>
                {designation && !isEditingDesignation ? (
                  <p className="f-12 mb-0 text-active fw-medium d-flex align-items-center mt-1">
                    <span className="text-dark-525">{designation}</span>
                    <Button
                      color="link"
                      size="sm"
                      className="p-0 ms-2 text-primary d-inline-flex align-items-center"
                      onClick={() => {
                        setDesignationInput(designation);
                        setIsEditingDesignation(true);
                      }}
                      title="Edit Designation"
                      type="button"
                    >
                      <FiEdit2 size={12} />
                    </Button>
                  </p>
                ) : (
                  <div
                    className="d-flex align-items-center gap-2 mt-2"
                    style={{ maxWidth: '260px' }}
                  >
                    <Input
                      value={designationInput}
                      placeholder="Enter Designation"
                      onChange={(e) => setDesignationInput(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleSaveDesignation();
                        }
                      }}
                      disabled={updatingDesignation}
                      className="f-12"
                    />
                    <Button
                      color="primary"
                      className="text-nowrap d-inline-flex align-items-center justify-content-center"
                      style={{ minWidth: '64px' }}
                      onClick={handleSaveDesignation}
                      disabled={
                        updatingDesignation || !designationInput?.trim()
                      }
                      type="button"
                    >
                      {updatingDesignation ? (
                        <Spinner size="sm" />
                      ) : (
                        <span>Save</span>
                      )}
                    </Button>
                    {designation && isEditingDesignation && (
                      <Button
                        color="link"
                        size="sm"
                        className="p-0 text-muted d-inline-flex align-items-center"
                        onClick={() => {
                          setIsEditingDesignation(false);
                          setDesignationInput(designation);
                        }}
                        disabled={updatingDesignation}
                        type="button"
                        title="Cancel"
                      >
                        <X size={16} />
                      </Button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </Col>

          <Col className="position-relative" sm={4} lg={4}>
            {userSubscription?.id ? (
              <div
                key={userSubscription?.subscriptionPlan?.id}
                className="me-1"
              >
                <div
                  key={userSubscription?.subscriptionPlan?.id}
                  className="me-1"
                >
                  <div className="user-info d-flex align-items-center">
                    <div className="info">
                      <h4 className="f-12 fw-medium mb-0 text-dark text-capitalize">
                        {`${userSubscription?.subscriptionPlan?.planName} Plan`}{' '}
                        {/* {userSubscription?.isTrial ? `(trial)` : ''} */}
                      </h4>
                      <p className="mb-0 mt-1 f-12 font-manrope text-active">
                        {moment(userSubscription?.deactivationDate).format(
                          'D MMM, YYYY',
                        )}
                      </p>
                      <VendorSubscriptionQuantity
                        id={id}
                        userSubscription={userSubscription}
                        callingCodeId={callingCodeId}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
            {isParentTrader && status !== 'DELETED' ? (
              <div
                className={
                  // userSubscription?.id ? `subscribe-btn-row ` : ''
                  userSubscription?.id
                    ? `subscribe-btn-row ${userSubscription?.isTrial ? 'ms-4 ps-2' : ''}`
                    : ''
                }
              >
                <Button
                  size="sm"
                  outline
                  className="small-btn xs-small-btn f-10"
                  color="primary"
                  // disabled={kycStatus === 'KYC_ACCEPTED' ? false : true}
                  onClick={() =>
                    toggleAddRecord(
                      userSubscription,
                      userSubscription?.id
                        ? ADD_EDIT_CONSTANT.EDIT
                        : ADD_EDIT_CONSTANT.ADD,
                    )
                  }
                >
                  {userSubscription?.id ? 'Switch' : 'Subscribe'}
                </Button>
                {userSubscription?.id ? (
                  <Button
                    size="sm"
                    outline
                    className="small-btn xs-small-btn f-10 ms-1"
                    color="primary"
                    disabled={
                      // (kycStatus === 'KYC_PENDING' ||
                      //   kycStatus === 'KYC_REJECTED') &&
                      userSubscription?.isTrial === true ? true : false
                    }
                    onClick={() =>
                      toggleAddOnRecord(userSubscription, ADD_EDIT_CONSTANT.ADD)
                    }
                  >
                    ADD-ON
                  </Button>
                ) : (
                  ''
                )}
              </div>
            ) : (
              ''
            )}
          </Col>
          {kycStatus === 'KYC_ACCEPTED' ? (
            <Col sm={2} lg={4}>
              <div className="d-flex align-items-center justify-content-end text-green">
                <RiVerifiedBadgeFill size={21} />
                <span className="fw-semibold f-12 font-manrope ms-1">
                  KYC Verified
                </span>
              </div>
            </Col>
          ) : (
            ''
          )}
        </Row>
      </CardWithTitle>

      <CardWithTitle title="Personal Details" className="vendor-personal-details">
        {/* <Col sm={5} xxl={5} className="mb-2">
            <span className="f-12 text-active fw-medium mb-1 d-block text-uppercase">
              PHONE NUMBER
            </span>
            <span className="f-12 text-dark-525 fw-medium d-block">
              {`${callingCode?.callingCode}-${phone}`}
            </span>
          </Col> */}
        {isParentTrader && (
          <Button
            className="f-12 text-primary text-decoration-none position-absolute p-0 card-right-link"
            color="link"
            onClick={toggleSellerCommission}
          >
            Commission History
          </Button>
        )}
        {callingCodeId === indiaCallingCodeId ? (
          <>
          <Row md={2} lg={4} className="align-items-center">
            <Col className="mb-2">
              <span className="f-12 text-active fw-medium mb-1 d-block text-uppercase">
                GST Number
              </span>
              <span className="f-12 text-dark-525 fw-medium d-block">
                {tradeGstIn ? tradeGstIn : 'Not Available'}
              </span>
              {(!tradeGstIn ||
                tradeGstIn === 'Not Available' ||
                tradeGstIn === 'N/A') && (
                  <GstVerificationInput vendorId={vendorId} refetch={refetch} />
                )}
            </Col>
            <Col className="mb-2">
              <span className="f-12 text-active fw-medium mb-1 d-block text-uppercase">
                PHONE NUMBER
              </span>
              <span className="f-12 text-dark-525 fw-medium d-block">
                {`${callingCode?.callingCode}-${phone}`}
              </span>
            </Col>
            <Col className="mb-2">
              <span className="f-12 text-active fw-medium mb-1 d-block text-uppercase">Address</span>
              <span className="f-12 text-dark-525 fw-medium d-block">
                {gstLocationParts.address || 'Not Available'}
              </span>
            </Col>
            <Col className="mb-2">
              <span className="f-12 text-active fw-medium mb-1 d-block text-uppercase">Pincode</span>
              <span className="f-12 text-dark-525 fw-medium d-block">{gstLocationParts.pinCode || 'Not Available'}</span>
            </Col>
            <Col className="mb-2">
              <span className="f-12 text-active fw-medium mb-1 d-block text-uppercase">City</span>
              <span className="f-12 text-dark-525 fw-medium d-block">{kyc?.gstCity || 'Not Available'}</span>
            </Col>
            <Col className="mb-2">
              <span className="f-12 text-active fw-medium mb-1 d-block text-uppercase">State</span>
              <span className="f-12 text-dark-525 fw-medium d-block">{kyc?.gstState || 'Not Available'}</span>
            </Col>
          </Row>
          <Row md={2} lg={4} className="align-items-center">
            <Col className="mb-2">
              <VendorAddOnListing traderId={id} />
            </Col>
            <VendorCommission callingCodeId={callingCodeId} vendorId={id} />
            <Col className="mb-2">
              <span className="f-12 text-active fw-medium mb-1 d-block text-uppercase">
                Total Volume Traded
              </span>
              <span className="f-12 text-dark-525 fw-medium d-block">
                {formatTradedVolume(totalTradedVolume)} MT
              </span>
            </Col>
          </Row>
          <Row md={2} lg={4} className="align-items-center">
            <Col className="mb-2">
              <span className="f-12 text-active fw-medium mb-1 d-block text-uppercase">RM</span>
              <span className="f-12 text-dark-525 fw-medium d-block">
                <RMField
                  defaultValue={dedicatedRM?.id ? { id: dedicatedRM.id, firstName: `${dedicatedRM.firstName} ${dedicatedRM.lastName}` } : ''}
                  handleChange={(e) => assignTradersToAnotherRM({ variables: { traders: id, dedicatedRM: e?.id } })}
                  id={id}
                />
              </span>
            </Col>
            <Col className="mb-2">
              <span className="f-12 text-active fw-medium mb-1 d-block text-uppercase">BDE</span>
              <span className="f-12 text-dark-525 fw-medium d-block">
                <BDEField
                  defaultValue={dedicatedBDE?.id ? { id: dedicatedBDE.id, firstName: `${dedicatedBDE.firstName} ${dedicatedBDE.lastName}` } : ''}
                  handleChange={(e) => assignTradersToAnotherBDE({ variables: { traders: id, dedicatedBDE: e?.id } })}
                  id={id}
                />
              </span>
            </Col>
            <Col className="mb-2">
              <span className="f-12 text-active fw-medium mb-1 d-block text-uppercase">Purchase Manager</span>
              <span className="f-12 text-dark-525 fw-medium d-block">
                <PMField
                  id={id}
                  defaultValue={selectedPurchaseManager || ''}
                  handleChange={(e) => {
                    setSelectedPurchaseManager(e || null);
                    try {
                      assignTradersToDedicatedPurchaseManager({
                        variables: {
                          traders: [getNumericId(id) || id],
                          managerId: getNumericId(e?.id) || e?.id,
                        },
                      });
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                />
              </span>
            </Col>
          </Row>
          </>
        ) : (
          <Row md={2} lg={4} className="align-items-center">
            <Col className="mb-2">
              <span className="f-12 text-active fw-medium mb-1 d-block text-uppercase">
                Company Formation Number
              </span>
              <span className="f-12 text-dark-525 fw-medium d-block">
                {companyFormationNumber || 'Not Available'}
              </span>
            </Col>
            <Col className="mb-2">
              <span className="f-12 text-active fw-medium mb-1 d-block text-uppercase">
                Location
              </span>
              <span className="f-12 text-dark-525 fw-medium d-block">
                {kyc?.gstLocation ? kyc?.gstLocation : 'Not Available'}
              </span>
            </Col>
            <Col className="mb-2">
              <span className="f-12 text-active fw-medium mb-1 d-block text-uppercase">
                RM
              </span>
              <span className="f-12 text-dark-525 fw-medium d-block">
                {dedicatedRM?.firstName
                  ? dedicatedRM?.firstName + ' ' + dedicatedRM?.lastName
                  : 'Not Available'}
              </span>
            </Col>
            <Col className="mb-2">
              <span className="f-12 text-active fw-medium mb-1 d-block text-uppercase">
                Purchase Manager
              </span>
              <span className="f-12 text-dark-525 fw-medium d-block">
                <PMField
                  id={id}
                  defaultValue={selectedPurchaseManager || ''}
                  handleChange={(e) => {
                    setSelectedPurchaseManager(e || null);
                    try {
                      assignTradersToDedicatedPurchaseManager({
                        variables: {
                          traders: [getNumericId(id) || id],
                          managerId: getNumericId(e?.id) || e?.id,
                        },
                      });
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                />
              </span>
            </Col>
          </Row>
        )}
      </CardWithTitle>
      <VendorFavouriteGrades favGrades={favGrades} />
      <VendorAdditionalUser currentRow={data?.traders?.traders[0]} />
      <CardWithTitle title="Identification">
        {callingCodeId === indiaCallingCodeId ? (
          <VendorKyc id={id} onTimelineRefresh={refreshVendorTimeline} />
        ) : (
          <VendorForeignKyc id={id} onTimelineRefresh={refreshVendorTimeline} />
        )}
      </CardWithTitle>
      <CardWithTitle title="Billing and Payment (Subscription)">
        <ErrorBoundary>
          <VendorBillingAndPayment id={id} />
        </ErrorBoundary>
      </CardWithTitle>

      <VendorDetailTabs
        vendorId={id}
        vendor={data?.traders?.traders?.[0]}
        onTimelineRefresh={refreshVendorTimeline}
      />
      <CardWithTitle title="Address Vendor">
        {addresses?.length ? (
          <List type="unstyled" className="address-list">
            {addresses.map(
              (item) =>
                (item?.houseNumber?.length ||
                  item?.street?.length ||
                  item?.city?.cityName?.length ||
                  item?.state?.stateName?.length ||
                  item?.country?.country?.length ||
                  item?.pinCode?.length) && (
                  <li key={item.id}>
                    <h4 className="f-14 mb-0 text-black4a4">
                      {item?.houseNumber || ''} {item?.street || ''}
                      {item?.street && ','} {item?.city?.cityName || ''}
                    </h4>
                    <span className="f-12 fw-medium d-block text-active">
                      {item?.state?.stateName || ''}
                      {item?.state?.stateName && ','}{' '}
                      {item?.country?.country || ''}
                      {item?.country?.country && ','} {item?.pinCode || ''}
                    </span>
                  </li>
                ),
            )}
          </List>
        ) : (
          <div className="mb-2">Not Available</div>
        )}
      </CardWithTitle>
      <CardWithTitle
        title={
          <span className="d-flex align-items-center">
            Timeline
            <button
              id="timeline-info-icon"
              type="button"
              className="p-0 border-0 bg-transparent ms-2"
              style={{ outline: 'none' }}
            >
              <FiInfo
                size={16}
                style={{ cursor: 'pointer', color: '#ffc107' }}
              />
            </button>
            <UncontrolledTooltip
              trigger="focus"
              placement="right"
              target="timeline-info-icon"
            >
              <div
                className="text-start f-12 p-1"
                style={{ maxHeight: '300px', overflowY: 'auto' }}
              >
                <div className="fw-bold mb-1 border-bottom pb-1">
                  Trigger list for Timeline
                </div>
                <ul className="mb-0 ps-3">
                  <li>Gst number Edit/Add</li>
                  <li>RM change via dropdown</li>
                  <li>BDM change via dropdown</li>
                  <li>Additional user added</li>
                  <li>Subcription plan update dropdown</li>
                  <li>Subcription plan add dropdown</li>
                  <li>Upload aadhar front image</li>
                  <li>Upload aadhar back image</li>
                  <li>Upload PAN card</li>
                  <li>Upload User verification document</li>
                  <li>Mark any favrate grade and sector</li>
                  <li>Update demand count</li>
                  <li>Whatsapp image , TDS eligible , user status toggle</li>
                  <li>Update payment status dropdown</li>
                  <li>KYC status update dropdown</li>
                  <li>Role udpate dropdown</li>
                  <li>Edit vendor udpate</li>
                  <li>Seller commision type droddown</li>
                  <li>Buyer commision type dropdown</li>
                </ul>
              </div>
            </UncontrolledTooltip>
          </span>
        }
        className="vendor-timeline-card"
      >
        <div className="vendor-timeline">{renderTimelineHistory()}</div>
        {canLoadMoreTimeline && (
          <div className="vendor-timeline-load-more">
            <Button
              outline
              color="primary"
              size="sm"
              className="f-12"
              onClick={() =>
                setVisibleTimelineEntries((currentCount) =>
                  Math.min(
                    currentCount + TIMELINE_ENTRIES_PER_PAGE,
                    totalTimelineEntries,
                  ),
                )
              }
            >
              Load More
            </Button>
          </div>
        )}
      </CardWithTitle>
    </>
  );
};

export default VendorDetails;
